
import {RADIO_SINGLE_RANDOM_VALUE, RadioButton} from "../prm/radio-button";
import {Name} from "../prm/name";
import {OptionMenu} from "../prm/option-menu";

const invest_start_amt = "invest_start_amt";

const contribute_yes_no = "contribute_yes_no";

const contribute_cadence = "contribute_cadence";

const contribute_amt = "contribute_amt";

// Number of years for running the portfolio
const ACCESS_FUNDS_YEARS_NAME = new Name("access_funds_years");

// Number of years for dispersing the portfolio
const SPEND_FUNDS_YEARS_NAME = new Name("spend_funds_years");

const ROLE_0_SOURCE_OF_FUNDS = new Name("role_0_source_of_funds");
const ROLE_0_OTHER_SOURCE = new Name("role_0_other_source");
const ROLE_1_SOURCE_OF_FUNDS = new Name("role_1_source_of_funds");
const ROLE_1_OTHER_SOURCE = new Name("role_1_other_source");

const AllNames = {
  invest_start_amt,
  contribute_yes_no,
  contribute_cadence,
  contribute_amt,
  ACCESS_FUNDS_YEARS_NAME,
  SPEND_FUNDS_YEARS_NAME,
  ROLE_0_SOURCE_OF_FUNDS,
  ROLE_0_OTHER_SOURCE,
  ROLE_1_SOURCE_OF_FUNDS,
  ROLE_1_OTHER_SOURCE,
};

const ROLLOVER_IRA_TEXT_2 = "Roll over a 401k";

const INVEST_FOR_INDEX = {
  transfer: 0,
  standard_invest_0: 1,
  IRA: 2,
  IRA_rollover: 3,
  custodial: 4,
  standard_invest_1: 5,
}

const INVEST_FOR = new RadioButton(
  new Name("invest_for"),
  [
    new Name("transfer", "Transfer an account from another firm"),
    new Name("standard_invest_0", "Put some money in the markets"),
    new Name("IRA", "Start an Individual Retirement Account"),
    new Name("IRA_rollover", ROLLOVER_IRA_TEXT_2),
    new Name("custodial", "Set up an account for a child"),
    new Name("standard_invest_1", "Put some money in the markets"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);

const INVEST_TYPE = new OptionMenu(
  new Name("invest_type"),
  [
    new Name("individual", "Individual"),
    new Name("spouse", "Spouse"),
  ]);

const CUSTODIAL_TYPE = new RadioButton(
  new Name("custodial_type"),
  [
    new Name("trust", "UGMA"),
    new Name("roth", "Custodial Roth"),
  ]
)
const IRA_TYPE = new RadioButton(
  new Name("ira_type"),
  [
    new Name("traditional", "Traditional IRA"),
    new Name("spousal", "Spousal IRA"),
    new Name("roth", "Roth IRA"),
    new Name("custodial", "Custodial IRA"),
  ]);

const CREATE_SOURCE_OF_FUNDS_PRM = prm_name => {
  return new RadioButton(
    prm_name,
    [
      new Name("salary_wages", "Employment/Wages"),
      new Name("property_sale", "Sale of a Property or Business"),
      new Name("investments", "Investment Gains"),
      new Name("family_inheritance", "From a Relative or an Inheritance"),
      new Name("gifts", "Gifts"),
      new Name("soc_security", "Social Security Benefits"),
      new Name("gambling", "Gambling or Lottery"),
      new Name("other", "Other"),
    ]);
}

const XFER_ACCT_TYPE = new RadioButton(
  new Name("xfer_acct_type"),
  [
    new Name("individual", "Individual"),
    new Name("joint_spouse", "Spouse as Community Property"),
    new Name("joint_tenants", "Joint Tenants with Rights of Survivorship"),
    new Name("tenants_common", "Tenants in Common"),
    new Name("ira", "IRA"),
    new Name("trust", "UGMA"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);

const XFER_IRA_TYPE = new RadioButton(
  new Name("xfer_ira_type"),
  [
    new Name("traditional_ira", "Transfer an IRA from another firm"),
    new Name("rollover_ira", "Rollover a 401k into a Rollover IRA"),
    new Name("roth_ira", "Transfer a Roth IRA"),
    new Name("sepp_ira", "Transfer a SEPP IRA"),
    new Name("simple_ira", "Transfer a SIMPLE IRA"),
  ]
);

export { AllNames, INVEST_TYPE, INVEST_FOR, INVEST_FOR_INDEX, IRA_TYPE,
  CREATE_SOURCE_OF_FUNDS_PRM, CUSTODIAL_TYPE, XFER_ACCT_TYPE, XFER_IRA_TYPE };
